import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Box,
} from '@material-ui/core';
import { SYSTEM_ERROR_TYPE } from '../../../common/const';
import { ERROR } from '../../../common/message';
import styles from './ErrorComponent.module.css';
/**
 * エラー画面コンポーネント
 */
class ErrorComponent extends Component {
  render() {
    const { systemErrorType } = this.props;
    let msg = ERROR.E09001;
    if (systemErrorType === SYSTEM_ERROR_TYPE.CSRF_NONE) {
      msg = ERROR.E09003;
    }
    if (systemErrorType === SYSTEM_ERROR_TYPE.CLOSE) {
      msg = ERROR.E09004;
    }
    return (
      <Box className={`${styles.paper}`}>
        <Box className={`${styles.mainfild}`}>
          <Box className={`${styles.contentserror}`}>
            <Box className={`${styles.message}`}>{msg}</Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    systemErrorType: state.common.systemErrorType,
  }),
)(ErrorComponent);
